import { render } from "./documentSignaturePopup.vue?vue&type=template&id=56d0c044&scoped=true"
import script from "./documentSignaturePopup.vue?vue&type=script&lang=js"
export * from "./documentSignaturePopup.vue?vue&type=script&lang=js"

import "./documentSignaturePopup.vue?vue&type=style&index=0&id=56d0c044&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d0c044"]])

export default __exports__